import * as React from 'react'
import { Wifi, WifiOff } from 'lucide-react'
import { cn } from '../lib/utils'
import { semanticSolidSurfaceClass, type SemanticBadgeTone } from 'helpers/kpiIconClass'

export interface ConnectionStatusChipProps extends React.HTMLAttributes<HTMLDivElement> {
 online: boolean
 labelWhenOnline: string
 labelWhenOffline: string
 /** When to show the text label beside the icon */
 showLabelFrom?: 'always' | 'sm' | 'never'
 pendingCount?: number
}

export function ConnectionStatusChip({
 online,
 labelWhenOnline,
 labelWhenOffline,
 showLabelFrom = 'sm',
 pendingCount = 0,
 className,
 title,
 ...props
}: ConnectionStatusChipProps) {
 const label = online ? labelWhenOnline : labelWhenOffline
 const tone: SemanticBadgeTone = online ? 'success' : 'danger'

 return (
 <div
 role="status"
 aria-live="polite"
 title={title ?? label}
 className={cn(
 'inline-flex shrink-0 items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[11px] font-bold tracking-tight',
 semanticSolidSurfaceClass(tone),
 className,
 )}
 {...props}
 >
 <span
 className="h-2 w-2 shrink-0 rounded-full bg-current opacity-90"
 aria-hidden
 />
 {online ? (
 <Wifi className="h-3.5 w-3.5 shrink-0 opacity-90" strokeWidth={2.25} aria-hidden />
 ) : (
 <WifiOff className="h-3.5 w-3.5 shrink-0 opacity-90" strokeWidth={2.25} aria-hidden />
 )}
 <span
 className={cn(
 'whitespace-nowrap',
 showLabelFrom === 'sm' && 'hidden sm:inline',
 showLabelFrom === 'never' && 'hidden',
 showLabelFrom === 'always' && 'truncate',
 )}
 >
 {label}
 </span>
 {pendingCount > 0 && (
 <span
 className={cn(
 'ms-0.5 inline-flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full border border-current/25 bg-current/15 px-1 text-[10px] font-bold tabular-nums',
 )}
 >
 {pendingCount}
 </span>
 )}
 </div>
 )
}
